export const FEATURE_FLAG_STORAGE_KEY = 'vs_feature_flags';

export const LocalStorageKeys = {
    ONBOARDING_STATE: 'vs_onboarding_state',
    HOME_HIDDEN: 'vs_home_hidden',
    ACCOUNT_ID: 'account_id',
    PROMPT_VERSION: '_vs_prompt_version',
    INSERT_OVERLAY_STATE: 'vs_insert_overlay_state',
};
